/** Ícones próprios do RPG Desk (traço simples, 24×24, `currentColor`). */

const PATHS = {
  user: 'M12 12a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm-8 9c0-4 3.6-6.5 8-6.5s8 2.5 8 6.5',
  lock: 'M6 11h12v10H6zM8.5 11V7.5a3.5 3.5 0 0 1 7 0V11',
  // mostrar e esconder a senha: o olho aberto e o olho riscado
  eye: 'M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12ZM12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z',
  eyeOff: 'M10.6 5.6A9.6 9.6 0 0 1 12 5.5c6 0 9.5 6.5 9.5 6.5a17 17 0 0 1-2.6 3.4M6.6 6.6C4 8.3 2.5 12 2.5 12S6 18.5 12 18.5c1.9 0 3.5-.6 4.9-1.5M9.9 9.9a3 3 0 0 0 4.2 4.2M3 3l18 18',
  mail: 'M3 6h18v12H3zM3 7l9 6 9-6',
  globe: 'M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18Zm-9 9h18M12 3c2.5 2.5 3.5 5.5 3.5 9s-1 6.5-3.5 9c-2.5-2.5-3.5-5.5-3.5-9s1-6.5 3.5-9Z',
  search: 'M10.5 4a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13ZM15.2 15.2 20 20',
  chevronDown: 'M6 9l6 6 6-6',
  chevronLeft: 'M15 6l-6 6 6 6',
  chevronUp: 'M6 15l6-6 6 6',
  minus: 'M5 12h14',
  userPlus: 'M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm-6 9v-1a5 5 0 0 1 5-5h2a5 5 0 0 1 5 5v1M19 8v6M16 11h6',
  check: 'M5 12.5l4.5 4.5L19 7.5',
  close: 'M6 6l12 12M18 6L6 18',
  maximize: 'M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5',
  restore: 'M9 4v5H4M15 4v5h5M9 20v-5H4M15 20v-5h5',
  // abrir em nova janela: caixa com seta saindo pelo canto
  popout: 'M14 4h6v6M20 4l-8 8M18 14v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h5',
  // o alto da mesa (docs/spec/room-menus.md): os painéis em colunas e o "mais ações" de um painel
  panels: 'M3.5 5h17v14h-17zM9 5v14M15 5v14',
  more: 'M5.5 12h.01M12 12h.01M18.5 12h.01',
  // navegação principal (desenhos próprios)
  dashboard: 'M12 2.5l8.5 5v9L12 21.5 3.5 16.5v-9L12 2.5Zm0 0v6m8.5-1L12 8.5 3.5 7.5M12 8.5l-5 8h10l-5-8Z',
  rooms: 'M4 20v-1.5C4 15.5 6.5 14 9 14s5 1.5 5 4.5V20M9 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm7 0a2.5 2.5 0 1 0 0-5M17 14c2 .3 3.5 1.8 3.5 4.5V20',
  contacts: 'M8 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm-5 9c0-3 2.2-5 5-5s5 2 5 5M16 8h5M18.5 5.5v5M15 14h6M15 17.5h4',
  cloud: 'M7 18h10a4 4 0 0 0 .5-8A5.5 5.5 0 0 0 7 9.5 4.3 4.3 0 0 0 7 18Z',
  settings:
    'M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm7.4-3a7.4 7.4 0 0 0-.1-1.2l2-1.6-2-3.4-2.4 1a7.4 7.4 0 0 0-2-1.2L14.5 3h-5l-.4 2.6a7.4 7.4 0 0 0-2 1.2l-2.4-1-2 3.4 2 1.6a7.4 7.4 0 0 0 0 2.4l-2 1.6 2 3.4 2.4-1a7.4 7.4 0 0 0 2 1.2l.4 2.6h5l.4-2.6a7.4 7.4 0 0 0 2-1.2l2.4 1 2-3.4-2-1.6c.1-.4.1-.8.1-1.2Z',
  logout: 'M15 4h4v16h-4M10 8l-4 4 4 4M6 12h11',
  // mídia
  play: 'M8 5.5v13l10.5-6.5L8 5.5Z',
  pause: 'M7 5h3.5v14H7zM13.5 5H17v14h-3.5z',
  stop: 'M6.5 6.5h11v11h-11z',
  next: 'M6 6l8.5 6L6 18V6ZM17.5 6v12',
  prev: 'M18 6l-8.5 6L18 18V6ZM6.5 6v12',
  repeat: 'M5 11V9a3 3 0 0 1 3-3h10m-3-3 3 3-3 3M19 13v2a3 3 0 0 1-3 3H6m3 3-3-3 3-3',
  volume: 'M4 9.5h3.5L12 5.5v13l-4.5-4H4zM15.5 9a4 4 0 0 1 0 6M18 6.5a7.5 7.5 0 0 1 0 11',
  mute: 'M4 9.5h3.5L12 5.5v13l-4.5-4H4zM16 9.5l5 5M21 9.5l-5 5',
  music: 'M9 18V5.5l11-2V16M9 18a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Zm11-2a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z',
  plus: 'M12 5v14M5 12h14',
  link: 'M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1',
  upload: 'M12 16V4M7 9l5-5 5 5M4 16v4h16v-4',
  download: 'M12 4v12M7 11l5 5 5-5M4 20h16',
  trash: 'M5 7h14M10 7V4.5h4V7M7 7l1 13h8l1-13',
  // limpar o chat (docs/spec/chat-delete.md): a borracha deitada sobre a linha
  eraser: 'M9 20h11M4.7 15.3a1.4 1.4 0 0 1 0-2l8.6-8.6a1.4 1.4 0 0 1 2 0l4.3 4.3a1.4 1.4 0 0 1 0 2L12 20H9.4l-4.7-4.7ZM8.5 11.5l5 5',
  bolt: 'M13 3 5 13.5h6L10 21l8-10.5h-6L13 3Z',
  // conferência
  mic: 'M12 3a3 3 0 0 0-3 3v6a3 3 0 0 0 6 0V6a3 3 0 0 0-3-3ZM5.5 11a6.5 6.5 0 0 0 13 0M12 17.5V21M8.5 21h7',
  micOff: 'M15 10V6a3 3 0 0 0-5.7-1.3M9 9v3a3 3 0 0 0 4.7 2.5M5.5 11a6.5 6.5 0 0 0 10.6 5M18.5 11a6.4 6.4 0 0 1-.5 2.5M12 17.5V21M8.5 21h7M4 4l16 16',
  camera: 'M3.5 7.5h11v9h-11zM14.5 10.5l6-3.5v10l-6-3.5',
  cameraOff: 'M3.5 7.5h3M10 7.5h4.5v4M14.5 14.5v2h-11v-9M14.5 10.5l6-3.5v10l-4-2.3M3 3l18 18',
  hangup: 'M3.5 14.5c4.7-4.7 12.3-4.7 17 0l-2.3 2.3-3.2-1.6v-2.4a8 8 0 0 0-6 0v2.4l-3.2 1.6z',
  // celular (docs/spec/mobile.md): o "Mais", as abas da mesa e o enviar do chat
  menu: 'M4 6.5h16M4 12h16M4 17.5h16',
  chat: 'M4 5h16v11H10l-5 4v-4H4z',
  map: 'M3 6l6-2 6 2 6-2v14l-6 2-6-2-6 2zM9 4v14M15 6v14',
  sheet: 'M6 3h9l4 4v14H6zM9 11h7M9 15h7M9 7h4',
  send: 'M4 12 20 4l-5.5 16-3-6.5z M11.5 13.5 20 4',
  // Desk Cloud (docs/spec/desk-cloud.md)
  folder: 'M3.5 6.5h6l2 2h9v10.5h-17z',
  folderPlus: 'M3.5 6.5h6l2 2h9v10.5h-17zM12 11v6M9 14h6',
  star: 'M12 3.5l2.6 5.4 5.9.8-4.3 4.1 1 5.8L12 16.8l-5.2 2.8 1-5.8-4.3-4.1 5.9-.8z',
  // curtir e não curtir uma mesa ou uma pessoa: o polegar, para cima e espelhado para baixo
  thumbUp: 'M7 10v11H3V10zM7 10l4-7a2 2 0 0 1 3 2l-1 5h6a2 2 0 0 1 2 2.3l-1.4 7A2 2 0 0 1 17.6 21H7',
  thumbDown: 'M7 14V3H3v11zM7 14l4 7a2 2 0 0 0 3-2l-1-5h6a2 2 0 0 0 2-2.3l-1.4-7A2 2 0 0 0 17.6 3H7',
  grid: 'M4 4h7v7H4zM13 4h7v7h-7zM4 13h7v7H4zM13 13h7v7h-7z',
  list: 'M9 6h11M9 12h11M9 18h11M4.5 6h.01M4.5 12h.01M4.5 18h.01',
  edit: 'M4 20h4L19 9l-4-4L4 16v4ZM13.5 6.5l4 4',
  file: 'M6 3h8l4 4v14H6zM14 3v4h4',
  clock: 'M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18ZM12 7.5V12l3 2',
  // o perfil: quando a pessoa costuma jogar, bloquear (o círculo cortado) e a capa (a paisagem)
  calendar: 'M4 5.5h16V20H4zM4 10h16M8.5 3v4M15.5 3v4',
  ban: 'M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18ZM5.6 5.6l12.8 12.8',
  image: 'M4 5h16v14H4zM4 16l4.5-4.5 3.5 3.5 2.5-2.5L20 17M15.5 8.5h.01',
  coin: 'M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18ZM14.5 9.2c-.4-.8-1.3-1.2-2.5-1.2-1.4 0-2.4.7-2.4 1.8s1 1.5 2.4 1.8 2.6.7 2.6 1.9-1.1 1.9-2.6 1.9c-1.2 0-2.1-.5-2.6-1.3M12 6.5V8M12 15.5V17',
  chevronRight: 'M9 6l6 6-6 6',
  arrowRight: 'M5 12h14M13 6l6 6-6 6',
  // escudo com o visto: a área de administração
  shield: 'M12 3 4.5 6v5.5c0 4.6 3.2 8.2 7.5 9.5 4.3-1.3 7.5-4.9 7.5-9.5V6L12 3ZM8.8 12.2l2.2 2.2 4.4-4.6',
  // escudo vazio: moderar o chat
  moderate: 'M12 3 4.5 6v5.5c0 4.6 3.2 8.2 7.5 9.5 4.3-1.3 7.5-4.9 7.5-9.5V6L12 3Z',
  // as seções das Configurações
  sliders: 'M4 7h9M17 7h3M15 5v4M4 17h3M11 17h9M9 15v4',
  die: 'M12 2.5l8.2 4.75v9.5L12 21.5l-8.2-4.75v-9.5zM12 7.5l4 7H8z',
  bell: 'M18 8.5a6 6 0 0 0-12 0c0 6.5-2.5 8.5-2.5 8.5h17S18 15 18 8.5M13.7 20.5a2 2 0 0 1-3.4 0',
  help: 'M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18ZM12 8.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7ZM5.6 5.6l4 4M14.4 14.4l4 4M14.4 9.6l4-4M5.6 18.4l4-4',
  monitor: 'M3 5h18v11H3zM8 20h8M12 16v4',
} as const;

export type IconName = keyof typeof PATHS;

export function Icon({ name, size = 20, strokeWidth = 2, filled = false }: { name: IconName; size?: number; strokeWidth?: number; filled?: boolean }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={filled ? 'currentColor' : 'none'}
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d={PATHS[name]} />
    </svg>
  );
}

/**
 * Marca do RPG Desk: o d20 visto de frente, o mesmo desenho de tools/make-icons.mjs (sem o fundo de
 * feltro). A luz vem do alto, à esquerda: as faces de baixo e da direita ficam mais escuras.
 */
const D20_POINTS = { ht: '60 19', hur: '96.4 40', hlr: '96.4 82', hb: '60 103', hll: '23.6 82', hul: '23.6 40', a: '60 36', b: '36 76', c: '84 76' };
const D20_FACES: [string, string][] = [
  ['ht hul a', '#efe4cb'],
  ['ht hur a', '#e3d6b8'],
  ['hul a b', '#e6dabd'],
  ['hur a c', '#d5c6a2'],
  ['hul hll b', '#d8caa6'],
  ['hur hlr c', '#c6b58e'],
  ['hll hb b', '#cbbb94'],
  ['hlr hb c', '#b9a77e'],
  ['hb b c', '#d9cba8'],
  ['a b c', '#fbf6e9'],
];
const d20 = (keys: string) =>
  keys
    .split(' ')
    .map((k) => D20_POINTS[k as keyof typeof D20_POINTS])
    .join(' ');

export function RpgDeskMark({ size = 120 }: { size?: number }) {
  const p = D20_POINTS;
  return (
    <svg width={size} height={size} viewBox="0 0 120 120" aria-hidden="true">
      {D20_FACES.map(([keys, fill]) => (
        <polygon key={keys} points={d20(keys)} fill={fill} />
      ))}
      <g fill="none" stroke="#24412e" strokeWidth="2.4" strokeLinejoin="round" strokeLinecap="round">
        <polygon points={d20('ht hur hlr hb hll hul')} />
        <polygon points={d20('a b c')} />
        <path d={`M${p.ht}L${p.a}M${p.hul}L${p.a}M${p.hur}L${p.a}M${p.hul}L${p.b}M${p.hll}L${p.b}M${p.hb}L${p.b}M${p.hur}L${p.c}M${p.hlr}L${p.c}M${p.hb}L${p.c}`} />
      </g>
      <text x="60" y="63.5" textAnchor="middle" dominantBaseline="central" fontFamily="var(--font-title)" fontSize="21" fontWeight="800" fill="#1d6236">
        20
      </text>
    </svg>
  );
}
